import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import DayPicker, { DateUtils, ModifiersUtils } from "react-day-picker";

const WeekPicker = (props) => {
  const { onPeriodSelected, startDate, endDate, maxRange, predefinedRange } =
    props;

  const adjustedMaxRange = maxRange - 1;

  function dateSelected(day, { disabled }) {
    if (disabled) {
      return;
    }

    const range = DateUtils.addDayToRange(day, {
      from: startDate,
      to: endDate,
    });

    let newRange;
    if (predefinedRange) {
      newRange = {
        startDate: moment(range.to || range.from)
          .endOf("isoWeek")
          .subtract(5, "weeks")
          .add(1, "days")
          .startOf("isoWeek")
          .toDate(),
        endDate: moment(range.to || range.from)
          .endOf("isoWeek")
          .toDate(),
      };
    } else if (maxRange === 10) {
      if (moment(range.to).diff(moment(range.from), "week") < 10) {
        newRange = {
          startDate: moment(range.from).startOf("isoWeek").toDate(),
          endDate: moment(range.to || range.from)
            .endOf("isoWeek")
            .toDate(),
        };
      } else {
        newRange = {
          startDate: moment(day)
            .subtract(adjustedMaxRange, "weeks")
            .startOf("isoWeek")
            .toDate(),
          endDate: moment(day).endOf("isoWeek").toDate(),
        };
      }
    } else {
      newRange = {
        startDate: moment(range.from).startOf("isoWeek").toDate(),
        endDate: moment(range.to || range.from)
          .endOf("isoWeek")
          .toDate(),
      };
    }

    if (
      newRange.startDate - startDate === 0 &&
      newRange.endDate - endDate === 0
    ) {
      if (maxRange === 10) {
        const selectedRange = {
          startDate: moment(newRange.startDate)
            .endOf("isoWeek")
            .subtract(5, "weeks")
            .add(1, "days")
            .startOf("isoWeek")
            .toDate(),
          endDate: moment(newRange.endDate || newRange.startDate)
            .endOf("isoWeek")
            .toDate(),
        };
        if (
          moment(selectedRange.endDate).diff(
            moment(selectedRange.startDate),
            "week"
          ) < 10
        ) {
          onPeriodSelected(selectedRange);
        }
      } else {
        const selectedRange = {
          startDate: moment(range.from)
            .endOf("isoWeek")
            .subtract(5, "weeks")
            .add(1, "days")
            .startOf("isoWeek")
            .toDate(),
          endDate: moment(range.to || range.from)
            .endOf("isoWeek")
            .toDate(),
        };
        onPeriodSelected(selectedRange);
      }
    } else {
      onPeriodSelected(newRange);
    }
  }

  const endOfThisWeek = moment().endOf("isoWeek").toDate();
  const maxRangeAfterStartDate = moment(startDate)
    .add(adjustedMaxRange, "weeks")
    .endOf("isoWeek")
    .toDate();
  const afterDisabledDays =
    endOfThisWeek > maxRangeAfterStartDate
      ? maxRangeAfterStartDate
      : endOfThisWeek;
  const disabledDays = {
    after:
      maxRange === 10 ? moment().endOf("isoWeek").toDate() : afterDisabledDays,
    before:
      endDate &&
      moment(endDate).subtract(5147, "weeks").startOf("isoWeek").toDate(),
  };
  return (
    <div>
      {predefinedRange ? (
        <DayPicker
          showWeekNumbers
          onWeekClick={(week, days) => {
            const disabled = ModifiersUtils.getModifiersForDay(days[0], {
              disabled: disabledDays,
            }).includes("disabled");
            dateSelected(days[0], { disabled });
          }}
          selectedDays={[
            endDate,
            {
              from: moment(endDate)
                .endOf("isoWeek")
                .subtract(5, "weeks")
                .add(1, "days")
                .startOf("isoWeek")
                .toDate(),
              to: endDate,
            },
          ]}
          modifiers={{ start: startDate, end: endDate }}
          firstDayOfWeek={1}
          /* eslint-disable react/jsx-no-bind */
          onDayClick={dateSelected}
          numberOfMonths={2}
          toMonth={endOfThisWeek}
          disabledDays={disabledDays}
        />
      ) : (
        <DayPicker
          showWeekNumbers
          onWeekClick={(week, days) => {
            const disabled = ModifiersUtils.getModifiersForDay(days[0], {
              disabled: disabledDays,
            }).includes("disabled");
            dateSelected(days[0], { disabled });
          }}
          selectedDays={[startDate, { from: startDate, to: endDate }]}
          modifiers={{ start: startDate, end: endDate }}
          firstDayOfWeek={1}
          /* eslint-disable react/jsx-no-bind */
          onDayClick={dateSelected}
          numberOfMonths={2}
          toMonth={endOfThisWeek}
          disabledDays={disabledDays}
        />
      )}
    </div>
  );
};

export default WeekPicker;

WeekPicker.propTypes = {
  onPeriodSelected: PropTypes.func,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  maxRange: PropTypes.number,
  predefinedRange: PropTypes.func,
};
